import { render, staticRenderFns } from "./tab16.vue?vue&type=template&id=2d7ac6aa&scoped=true&"
import script from "./tab16.vue?vue&type=script&lang=js&"
export * from "./tab16.vue?vue&type=script&lang=js&"
import style0 from "./tab16.vue?vue&type=style&index=0&id=2d7ac6aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7ac6aa",
  null
  
)

export default component.exports